import "../Events.js";
/** @namespace Security */
NS("Security");

/**
 * @class
 * @extends Events
 */
Security.Context = Class(Events, /** @lends Security.Context.prototype */ {
    role: null,
    user: null,
    sessionId: null,
    options: null,
    organization: null,
    userProfile: null,

    update: function(data) {
        this.role = data.role;
        this.user = data.user;
        this.sessionId = data.sessionId;
        this.options = data.options;
        this.organization = data.organization;
        this.userProfile = data.userProfile;

        this.emit("update");

        return this;
    },

    value: function(path) {
        var value = null;

        try {
            eval("value = this." + path + ";");
        } catch (e) {}

        return value;
    },

    option: function(path) {
        return this.value("options." + path);
    }
});
